import React from 'react';
import VpBarcodeScanIcon from '@vtmn-play/icons/react/VpBarcodeScanIcon';
import { VpIconButton } from '@vtmn-play/react/layered';

interface MobileScanProps {
  readonly onScanClick: () => void;
}

export function MobileScan({ onScanClick }: MobileScanProps) {
  return (
    <VpIconButton variant="ghost" onClick={onScanClick}>
      <VpBarcodeScanIcon />
    </VpIconButton>
  );
}
